import {
  SLIDE_TWO_DRAG_DROP,
  SLIDE_TWO_REMOVE_STEP,
  SLIDE_TWO_SET_AS_NEXT_STEP,
  SLIDE_TWO_APPLY_HINT,
  SLIDE_TWO_SELECT_PATH,
} from '../../Redux.constants';
import {
  slideTwoDragDrop,
  slideTwoRemoveDrop,
  slideTwoSetAsNextStep,
  slideTwoApplyHint,
  slideTwoSelectPath,
} from './helper';

export function SlideTwoReducer(state = {}, action) {
  switch (action.type) {
    case SLIDE_TWO_DRAG_DROP:
      return slideTwoDragDrop(state, action.payload);
    case SLIDE_TWO_REMOVE_STEP:
      return slideTwoRemoveDrop(state, action.payload);
    case SLIDE_TWO_SET_AS_NEXT_STEP:
      return slideTwoSetAsNextStep(state, action.payload);
    case SLIDE_TWO_APPLY_HINT:
      return slideTwoApplyHint(state, action.payload);
    case SLIDE_TWO_SELECT_PATH:
      return slideTwoSelectPath(state, action.payload);
    default:
      return state;
  }
}
